var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata"},[(_vm.show)?_c('van-loading',{attrs:{"color":"#0294FF","vertical":""}},[_vm._v("加载中...")]):_c('div',[_c('van-image',{attrs:{"src":require('../assets/nopro.png')}}),_c('div',[_vm._v("暂无数据")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }